import React from 'react';
import PropTypes from 'prop-types';

import { useProps, useClassName } from 'components/pure/hooks';

const propTypes = {}
const imutableProps = {}
const mutableProps = {}

const classNames = {
  default: 'text-uppercase',
}

export default function Label({ children, className, ...props }) {
  className = useClassName(classNames, className)

  return <b {...useProps(props, imutableProps)} className={className}>
    {children}
  </b>
}

Label.propTypes = propTypes
Label.defaultProps = mutableProps